const SubscriptionStatus = {
  ACTIVE: 'active',
  CANCELED: 'canceled',
  DEPROVISIONED: 'deprovisioned',
  DOWNGRADED: 'downgraded',
  EXPIRED: 'expired',
  FAILED: 'failed',
  FROZEN: 'frozen',
  INITIATED: 'initiated',
  PENDING: 'pending',
  UPGRADED: 'upgraded',
} as const;

export const ACTIVE_STATUSES = [
  SubscriptionStatus.ACTIVE,
  SubscriptionStatus.CANCELED,
  SubscriptionStatus.EXPIRED,
  SubscriptionStatus.FROZEN,
];

export default SubscriptionStatus;
